/* Breadcrumb path lives in the navbar (c2e-header-place). */
const PageTitle = () => null;

export default PageTitle;
